import { Component, OnInit, Input, AfterViewInit, ElementRef } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit, AfterViewInit {

  constructor(private el: ElementRef) { }

  @Input() maxValue = 100;
  @Input() value    = 0;
  @Input() label    = '0%';

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.paint(this.maxValue, this.value, this.label);
  }

  paint(maxValue: number, value: number, label: string) {
    // Angles are in radians. 2π(radians) = 360°
    const startAngle  = 0;
    const endAngle    = (value / maxValue) * 2 * Math.PI;
    const innerRadius = 20;
    const outerRadius = 23;
    const pathData    = d3.arc()({startAngle, endAngle, innerRadius, outerRadius});
    const svg         = d3.select(this.el.nativeElement).select('g');

    const backPathData = d3.arc()({ startAngle: 0, endAngle: 2 * Math.PI, innerRadius, outerRadius });
    svg.append('path')
       .attr('fill', 'lightgrey')
       .attr('d', backPathData);

    // Set width and height
    svg.append('path')
      //  .attr('stroke-linejoin', 'round')
      //  .attr('stroke-width', '4px')
      //  .attr('stroke', 'black')
       .attr('fill', '#3978FF')
       .attr('d', pathData);

  }

}
